export const environment = {
  production: false,
  // apiUrl: 'http://localhost:8000/api/v1',
  apiUrl: 'https://elanglam-api.trailzyz.com/api/v1',
  featureFlag: true,
  secretKey: 'X9v!2pQ@kL7r$4wY8sZ#1tF&6bM0cD2!',
  version: '1782305749810'
};
